// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"3":"3ea2054c","43":"e4de74fc","249":"b0e9b25a","332":"4900cbf6","384":"5c11a87d","673":"f7af2242","793":"87498f48","866":"4cfc4ae2","950":"39f7aa37"}[chunkId] + ".chunk.js";
};